import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  body: {
    fontFamily: "Philosopher",

    "& p": {
      fontFamily: "Philosopher",
    },

    "& .MuiPaper-root": {
      backgroundColor: theme.palette.background.modalBg,
      color: theme.palette.text.primary,
      display: "flex",
      flexDirection: "column",
      borderRadius: "16px",
      fontFamily: "Philosopher",
      fontWeight: 900,
      gap: 8,
    },

    "& .MuiDialog-paper": {
      overflowY: "initial",
    },
  },

  modalContent: {
    position: "relative",
  },

  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: 48,
    minWidth: 320,
    backgroundSize: "auto 100%",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      padding: "48px 24px",
      minWidth: 300,
    },
  },

  closeIconBody: {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    right: 25,
    top: 25,
    zIndex: 1,

    "&>button": {
      padding: 0,
      minWidth: "auto",
      "&>svg": {
        color: theme.palette.text.secondary,
        cursor: "pointer",
        transition: ".3s",
        fontSize: "1.5rem",
        "&:hover": {
          color: theme.palette.text.primary,
          transition: ".3s",
        },
      },
    },
  },

  title: {
    fontSize: "24px",
  },

  swapItem: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },

  sellInput: {
    maxWidth: "160px",

    "& fieldset": {
      border: "none",
      outline: "none",
    },

    "& .MuiOutlinedInput-input": {
      padding: "14px 0",
      fontSize: "18px",
    },
  },

  swapTokenSelect: {
    minWidth: "160px",
    borderRadius: "30px",

    "& .MuiSelect-select": {
      backgroundColor: "#262729",
      color: "white",
      borderRadius: "30px",
    },

    [theme.breakpoints.down("sm")]: {
      maxWidth: "160px",
      minWidth: "auto",
    },
  },

  selectItem: {
    minWidth: "160px",
    borderRadius: "30px",
    border: "none",

    [theme.breakpoints.down("sm")]: {
      minWidth: "160px",
    },

    "& fieldset": {
      border: "none",
      borderRadius: "30px",
    },

    "& .MuiOutlinedInput-input": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",

      "&>div:nth-of-type(2)": {
        display: "none",
      },

      "&:focus": {
        borderRadius: "30px",
      },
    },
  },

  swapIconBox: {
    position: "absolute",
    bottom: -32,
    width: "50px",
    height: "50px",
    border: "4px solid #0d0f11",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "12px",
    left: "50%",
    marginLeft: "-25px",
    backgroundColor: "#1e1f21",

    "& svg": {
      fontSize: "32px",
    },
  },

  maxButton: {
    padding: "0",
    backgroundColor: "#353536",
    color: "#808080",

    "&:hover": {
      color: "white",
      backgroundColor: "#1976d2",
    },
  },

  activeButton: {
    color: "white",
    backgroundColor: "#1976d2",
  },

  swapButtonBox: {
    width: "100%",
    boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.4)",
    marginTop: "18px",

    [theme.breakpoints.down("sm")]: {},
  },

  swapButton: {
    width: "100%",
    padding: "12px",
    textTransform: "none",
    borderRadius: "8px",
    background: "linear-gradient(to right, #3a5d23, #1e3b0f)",
    color: "#ffffff",
    border: "none",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.4)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.6)",
      background: "linear-gradient(to right, #32491b, #122e0a)",
    },

    "&:disabled": {
      color: "rgba(255,255,255,0.4)",
      background: "#1e1f21",
    },
  },
}));

export default styles;
